// extracted by mini-css-extract-plugin
module.exports = {"option":"DeliveryOptions_option__rBRGZ","headline":"DeliveryOptions_headline__EaD49","description":"DeliveryOptions_description__O5Sj0","price":"DeliveryOptions_price__piNxB"};